import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WHATSAPP_CONFIG } from "@/config/constants";
import { PurchaseNotifications } from "@/components/PurchaseNotifications";
import Index from "./pages/Index";
import VSL from "./pages/VSL";
import LdaAltLanding from "./pages/LdaAltLanding";
import NotFound from "./pages/NotFound";
import OitoPilares from "./pages/8Pilares";
import MetodoLDA from "./pages/MetodoLDA";
import Linktree from "./pages/Linktree";
import Quiz from "./pages/Quiz";
import Obrigado from "./pages/Obrigado";
import NaoObrigado from "./pages/NaoObrigado";
import Main from "./pages/Main";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <PurchaseNotifications />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/main" element={<Main />} />
          <Route path="/vsl" element={<VSL />} />
          {/* <Route path="/alt" element={<LdaAltLanding waLink={WHATSAPP_CONFIG.groupLink}/>} /> */}
          <Route path="/8pilares" element={<OitoPilares/>} />
          <Route path="/metodolda" element={<MetodoLDA/>} />
          <Route path="/linktree" element={<Linktree/>} />
          <Route path="/alt" element={<Quiz/>} />
          <Route path="/obrigado" element={<Obrigado/>} />
          <Route path="/final" element={<NaoObrigado/>} />
          {/* <Route path="/quiz" element={<Quiz/>} /> */}
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter> 
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
